import {
    Dialog, DialogContent, DialogHeader, DialogTitle
} from 'shared/components/ui/dialog';
import {
    Button
} from 'shared/components/ui/button';
import {
    Input
} from 'shared/components/ui/input';
import {
    Label
} from 'shared/components/ui/label';
import {
    X
} from 'lucide-react';
import {
 JSX
} from 'react';
import {
 OpCode
} from '../types/storyBuilder.types';

interface SectionConfig {
    title?: string;
    // Add more properties based on the section configuration structure
}

interface OpCodeConfigModalProps {
    isOpen: boolean;
    onClose: () => void;
    opCode: OpCode;
    sectionConfig: SectionConfig;
    onSave: (updatedConfig: SectionConfig) => void;
}

export default function OpCodeConfigModal({
    isOpen, onClose, opCode, sectionConfig, onSave
}: OpCodeConfigModalProps): JSX.Element {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-[600px]">
                <DialogHeader>
                    <DialogTitle>Configure {opCode.name}</DialogTitle>
                    <Button variant="ghost" size="icon" className="absolute right-4 top-4" onClick={onClose}>
                        <X className="h-4 w-4" />
                    </Button>
                </DialogHeader>
                <div className="py-4">
                    <div className="space-y-4">
                        {opCode.type === 'table' && (
                            <>
                                <div className="space-y-2">
                                    <Label>Table Title</Label>
                                    <Input
                                        value={sectionConfig.title || ''}
                                        onChange={(e) => onSave({
                                            ...sectionConfig,
                                            title: e.target.value
                                        })}
                                        placeholder="Enter table title"
                                    />
                                </div>
                                {/* Add more table-specific configuration fields */}
                            </>
                        )}
                        {opCode.type === 'form' && (
                            <>
                                <div className="space-y-2">
                                    <Label>Form Title</Label>
                                    <Input
                                        value={sectionConfig.title || ''}
                                        onChange={(e) => onSave({
                                            ...sectionConfig,
                                            title: e.target.value
                                        })}
                                        placeholder="Enter form title"
                                    />
                                </div>
                                {/* Add more form-specific configuration fields */}
                            </>
                        )}
                        {/* Add more OpCode type configurations as needed */}
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}